<template>
  <v-layout row>
    <v-flex xs12>
      <v-card>
        <v-card-title class="project white--text">
          <div class="headline">Pre Survey Questions</div>
        </v-card-title>
        <v-card-text>
            <div v-for="(pre_ques,index) in pre_question" v-bind:key="index">
              <!-- question part -->
              <div>
                <span>Pre_Q{{index+1}}.</span>
                <span v-if="project_language ==1 || project_language ==3">
                <span class="font-weight-bold">Question Title English:</span> &nbsp;&nbsp;&nbsp;{{ pre_ques.question_title_en }}
                </span>
                <br />
                <span v-if="project_language ==2 || project_language ==3">
                &nbsp;&nbsp;&nbsp; <span class="font-weight-bold">Question Title Bangla:</span> &nbsp;&nbsp;&nbsp;{{ pre_ques.question_title_bn }} <br />
                </span> 
                <!-- option and multiple image section -->
                <div v-if="pre_ques.ui_category_id ==1 || pre_ques.ui_category_id ==2 || pre_ques.ui_category_id ==4 || pre_ques.ui_category_id ==14">
                  <div v-if="pre_ques.ui_category_id ==14">
                    <span v-for="(option, i) in (pre_ques.pre_image_options)" :key='i'>
                      <v-img height="150" width="200" :src="indexData.dataStatus8.pre_image_op + option.url"></v-img>
                      <a :href="indexData.dataStatus8.pre_image_op + option.url" target="_blank">download</a>
                      <div class="mt-3"></div>
                    </span>
                  </div>
                  <div v-else>
                    <div v-if="project_language ==1 || project_language ==3">
                      <span class="font-weight-bold">Option English:</span> <br>
                      <span v-for="(option, i) in (pre_ques.pre_options)" :key='i'>
                        <v-icon small>
                        radio_button_unchecked
                        </v-icon>
                        {{option.title}}<br> 
                      </span>
                    </div>
                    <div v-if="project_language ==2 || project_language ==3">
                      <br> <span class="font-weight-bold">Option Bangla:</span> <br>
                      <span v-for="(option, i) in (pre_ques.pre_bangla_options)" :key='i'>
                        <v-icon small>
                        radio_button_unchecked
                        </v-icon>
                        {{option.title}}<br> 
                      </span>
                    </div>
                  </div>
                </div>
                <!-- instruction and description -->
                <div>
                  <span
                    v-if="pre_ques.pre_instruction != null && (project_language ==1 || project_language ==3)">
                  <span class="font-weight-bold"> Instruction:
                    </span> <br />
                    &nbsp;&nbsp;&nbsp;<div v-html="ques.instruction.instruction"></div>
                  </span>
                  <span
                    v-if="pre_ques.pre_instruction_bangla != null && (project_language ==2 || project_language ==3)">
                  <span class="font-weight-bold"> Instruction Bangla:
                    </span> <br />
                    &nbsp;&nbsp;&nbsp;<div v-html="ques.pre_instruction_bangla.instruction_bangla"></div>
                  </span>

                  <span
                    v-if="pre_ques.pre_description != null && (project_language ==1 || project_language ==3)">
                  <span class="font-weight-bold"> Description:
                    </span> <br />
                    &nbsp;&nbsp;&nbsp;<div v-html="pre_ques.pre_description.description"></div>
                  </span>
                  <span
                    v-if="pre_ques.pre_description_bangla != null && (project_language ==2 || project_language ==3)">
                  <span class="font-weight-bold"> Description Bangla:
                    </span> <br />
                    &nbsp;&nbsp;&nbsp;<div v-html="pre_ques.pre_description_bangla.description_bangla"></div>
                  </span>
                  
                </div>
              </div>
              <div>
                <pre-survey-question-logic :pre_question_logic="pre_ques.pre_question_logic" :operators="indexData.operators"/>
              </div>
            </div>
          <!-- end question section -->
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout> 
</template>
<script>
import {mapGetters} from 'vuex'
import { PreSurveyQuestionLogic } from "@/components/index";
  export default {
    props: {
      pre_question: [],
      project_language: Number,
      baseUrl:String,
    },
    components:{
    PreSurveyQuestionLogic
    },
    
    computed: {
      ...mapGetters(['indexData', 'error', 'statusCode', 'errorMsg']),
      isLoaded() {
        if (this.indexData.dataStatus8) {
          return true;
        } else {
          return false;
        }
      }, 
    },

    // created () {
    //   this.initialize('indexData.dataStatus8')
    // },

    methods: {
      initialize () {
      },
      parseDataToJson(value){
        if(value != undefined){
          return JSON.parse(value);
        }
        return "";
        
      },

       setErrorZero () {
        this.$store.dispatch('setErrorZero')
      },
    }
  }
</script>
<style lang="stylus" scoped>
  .v-progress-circular
    margin: 1rem
  .imageResize
    width: auto
    height: auto
  .project {
    background: #ff2e2e;
  }
</style>